import React, { useCallback, useEffect, useRef } from 'react'
import clsx from 'classnames'
import styles from './Popup.module.scss'

type PopupProps = {
  active: boolean,
  onClose: () => void,
  className?: string,
  backDropClassName?: string,
  children: React.ReactNode,
  /** Kept for old call sites; has no effect */
  place?: string,
}

/** A dropdown panel that closes on any click outside it */
export const Popup: React.FC<PopupProps> = (props) => {
  const { active, children, className, backDropClassName, onClose } = props
  const container = useRef<HTMLDivElement>(null)

  const handleDocumentClick = useCallback((e: MouseEvent) => {
    if (container.current && !container.current.contains(e.target as Node)) {
      onClose()
    }
  }, [onClose])

  useEffect(() => {
    if (!active) {
      return undefined
    }
    document.addEventListener('click', handleDocumentClick)
    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  }, [active, handleDocumentClick])

  if (!active) {
    return null
  }

  return (
    <>
      <div
        ref={container}
        className={clsx([styles.content, className])}
        onClick={(e) => e.stopPropagation()}
      >
        <i className={styles.exit} onClick={onClose} />
        {children}
      </div>
      <div className={clsx([styles.backDrop, backDropClassName])} />
    </>
  )
}
